module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('section', {
    staticClass: "navbar-left",
    style: ({
      minHeight: _vm.screenHeight
    })
  }, [_c('app-navbar')], 1), _vm._v(" "), _c('section', {
    staticClass: "router-view-box",
    style: ({
      height: _vm.screenHeight
    })
  }, [_c('level-bar'), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    staticClass: "router-view"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c835671!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/container.vue
// module id = 308
// module chunks = 3